var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1384,
    height: 150,
    viewBox: "0 0 1384 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M16,0H1368a16,16,0,0,1,16,16V150a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    transform: "translate(499 119)",
    fill: "rgba(124,14,111,0.08)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12419",
    "data-name": "Group 12419",
    transform: "translate(-498 -225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    d: "M16,0H1368a16,16,0,0,1,16,16V150a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    transform: "translate(498 225)",
    fill: "rgba(124,14,111,0.08)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12416",
    "data-name": "Group 12416",
    transform: "translate(-350 -243.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12400",
    "data-name": "Group 12400",
    transform: "translate(848 469.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12394",
    "data-name": "Group 12394",
    transform: "translate(0 76.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M89.932,313.518a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,89.932,313.518Z",
    transform: "translate(-20.634 -244.219)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M68.191,291.777a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,68.191,291.777Z",
    transform: "translate(-16.104 -239.689)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M46.451,270.036a1.553,1.553,0,1,1,0,2.2A1.554,1.554,0,0,1,46.451,270.036Z",
    transform: "translate(-11.574 -235.159)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M2.969,226.554a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,2.969,226.554Z",
    transform: "translate(-2.515 -226.1)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12395",
    "data-name": "Group 12395",
    transform: "translate(15.38 61.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M109.36,294.09a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,109.36,294.09Z",
    transform: "translate(-40.062 -224.791)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M87.619,272.349a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,87.619,272.349Z",
    transform: "translate(-35.532 -220.261)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M65.878,250.608a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,65.878,250.608Z",
    transform: "translate(-31.002 -215.731)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12396",
    "data-name": "Group 12396",
    transform: "translate(30.759 46.14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(68.844 68.844)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(51.633 51.633)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M85.306,231.18a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,85.306,231.18Z",
    transform: "translate(-50.429 -196.303)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M63.566,209.439a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,63.566,209.439Z",
    transform: "translate(-45.9 -191.774)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M41.825,187.7a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,41.825,187.7Z",
    transform: "translate(-41.37 -187.244)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12397",
    "data-name": "Group 12397",
    transform: "translate(46.14 30.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M148.216,255.234a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,148.216,255.234Z",
    transform: "translate(-78.917 -185.935)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M126.475,233.493a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,126.475,233.493Z",
    transform: "translate(-74.387 -181.405)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M104.734,211.752a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,104.734,211.752Z",
    transform: "translate(-69.857 -176.875)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M61.253,168.271a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,61.253,168.271Z",
    transform: "translate(-60.798 -167.816)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12398",
    "data-name": "Group 12398",
    transform: "translate(61.52 15.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M167.644,235.806a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,167.644,235.806Z",
    transform: "translate(-98.345 -166.507)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M145.9,214.065a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,145.9,214.065Z",
    transform: "translate(-93.815 -161.977)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M124.162,192.324a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,124.162,192.324Z",
    transform: "translate(-89.286 -157.448)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12399",
    "data-name": "Group 12399",
    transform: "translate(76.9 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(68.844 68.844)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(51.633 51.633)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M143.59,172.9a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,143.59,172.9Z",
    transform: "translate(-108.713 -138.019)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M121.849,151.155a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,121.849,151.155Z",
    transform: "translate(-104.184 -133.49)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M100.109,129.415a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,100.109,129.415Z",
    transform: "translate(-99.654 -128.96)",
    fill: "#ffaf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12406",
    "data-name": "Group 12406",
    transform: "translate(871.747 512.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M58.321,219.126a5.937,5.937,0,0,1-4.2-10.135,8.114,8.114,0,1,0-11.475-11.476,5.938,5.938,0,1,1-8.4-8.4,19.989,19.989,0,0,1,28.269,28.269A5.917,5.917,0,0,1,58.321,219.126Z",
    transform: "translate(-32.511 -183.273)",
    fill: "#7c0e6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12408",
    "data-name": "Group 12408",
    transform: "translate(864.743 594.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M30.668,301.4a7,7,0,1,1,7-7A7.012,7.012,0,0,1,30.668,301.4Zm0-9.505a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.668,291.891Z",
    transform: "translate(-23.664 -287.389)",
    fill: "#ffaf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12402",
    "data-name": "Group 12402",
    transform: "translate(1320.609 230.016)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x1: 47.099,
    y1: 51.481,
    transform: "translate(87.733 20.921)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x1: 47.789,
    y1: 52.235,
    transform: "translate(95.573 52.402)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x1: 47.789,
    y1: 52.235,
    transform: "translate(123.716 26.443)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x1: 24.855,
    y1: 27.167,
    transform: "translate(112.495 101.542)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x1: 12.928,
    y1: 14.131,
    transform: "translate(180.646 74.522)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x1: 32.769,
    y1: 35.818,
    transform: "translate(69.144 62.472)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x1: 7.941,
    y1: 8.68,
    transform: "translate(164.865 40.717)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x1: 5.479,
    y1: 5.988,
    transform: "translate(78.071 109.03)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-1 106)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34616",
    "data-name": "Path 34616",
    d: "M439.745,0,371.462,59.321c-12.338,10.748-27.639,19.162-43.87,20.715-24.048,2.3-46.8-10.481-70.754-6.74-15.891,2.479-30.069,11.977-42.169,22.57s-21.894,24.032-35.927,32.12c-11.262,6.493-20.272,11.54-29.525,13.753a1.507,1.507,0,0,0,.045,2.941c9.63,1.972,19.5,5.388,27.7,10.685,12.736,8.227,23.114,19.171,34.862,28.572s25.618,17.494,41.446,18.391c23.863,1.342,47.106-13.744,71.12-13.848,16.2-.066,31.237,6.827,43.217,16.36,9.544,7.59,17.413,16.8,24.887,26.276l9.927,14.67,16.308,28.269s235.808-50.176,241.061-118.69S439.745,0,439.745,0Z",
    transform: "translate(724.939 56.971)",
    fill: "#ffa031",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12712",
    "data-name": "Group 12712",
    transform: "translate(-1966 23626.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34610",
    "data-name": "Path 34610",
    d: "M38.034,136.325l5.119,14.053,13.19-.45a3.537,3.537,0,0,0,3.237-4.646l-3.14-9.488Z",
    transform: "translate(2707.428 -23546.865)",
    fill: "#52144a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34611",
    "data-name": "Path 34611",
    d: "M25.385,145.1l7.442,21.519a8.652,8.652,0,0,0,16.4-5.53l-5.431-16.521Z",
    transform: "translate(2712.688 -23550.514)",
    fill: "#7c0e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34612",
    "data-name": "Path 34612",
    d: "M187.641,98.179c.21,6.141-2.23,11.209-5.449,11.318s-6-4.779-6.208-10.921,2.23-11.209,5.449-11.318,6,4.779,6.208,10.921",
    transform: "translate(2650.065 -23526.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34613",
    "data-name": "Path 34613",
    d: "M47.523,53.556,9.708,54.846a6.175,6.175,0,0,0-5.961,6.382l.513,15.017.513,15.017a6.175,6.175,0,0,0,6.382,5.961l37.816-1.29c37.594-1.283,59.1,20.564,59.1,20.564l-1.492-43.743L105.086,29.01S85.117,52.273,47.523,53.556",
    transform: "translate(2721.688 -23502.459)",
    fill: "#7c0e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34614",
    "data-name": "Path 34614",
    d: "M177.855,14.519a3.522,3.522,0,0,0-.1-.712,3.577,3.577,0,0,0-1.491-2.123c-.071-.047-.143-.091-.216-.133a3.587,3.587,0,0,0-.567-.262,3.5,3.5,0,0,0-.946-.2,3.558,3.558,0,0,0-3.8,3.674l3.341,97.889a3.561,3.561,0,1,0,7.117-.243Z",
    transform: "translate(2652.243 -23495.002)",
    fill: "#ffaf2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34615",
    "data-name": "Path 34615",
    d: "M52.286,91.914,51.56,70.63c-1.324.1-2.664.187-4.035.234L9.709,72.154a6.172,6.172,0,0,0-5.834,4.934h0a6.166,6.166,0,0,0-.1.676c0,.016,0,.032-.006.047a6.32,6.32,0,0,0-.021.723L4.26,93.553,4.3,94.817l.469,13.753a6.175,6.175,0,0,0,6.382,5.961l37.816-1.29c.547-.019,1.087-.027,1.625-.034.375,0,.749-.008,1.122-.008.433,0,.866,0,1.3,0Z",
    transform: "translate(2721.687 -23519.766)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12417",
    "data-name": "Group 12417",
    transform: "translate(93.933 -73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12403",
    "data-name": "Group 12403",
    transform: "translate(1748.904 253.986)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 13.207,
    cy: 13.207,
    r: 13.207,
    transform: "translate(4.75 4.75)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 13.207,
    cy: 13.207,
    r: 13.207,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12415",
    "data-name": "Group 12415",
    transform: "translate(1608.416 195.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12409",
    "data-name": "Group 12409",
    transform: "translate(0 74.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M330.335,211.953a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,330.335,211.953Z",
    transform: "translate(-263.116 -144.734)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M308.595,190.212a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,308.595,190.212Z",
    transform: "translate(-258.07 -139.687)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M286.854,168.471a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,286.854,168.471Z",
    transform: "translate(-253.023 -134.641)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.694)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M243.372,124.99a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,243.372,124.99Z",
    transform: "translate(-242.931 -124.549)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12410",
    "data-name": "Group 12410",
    transform: "translate(14.919 59.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M349.763,192.525a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,349.763,192.525Z",
    transform: "translate(-282.544 -125.306)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M328.023,170.784a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,328.023,170.784Z",
    transform: "translate(-277.498 -120.259)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M306.282,149.043a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,306.282,149.043Z",
    transform: "translate(-272.451 -115.213)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12411",
    "data-name": "Group 12411",
    transform: "translate(29.837 44.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(66.778 66.778)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(50.084 50.083)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M325.71,129.615a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,325.71,129.615Z",
    transform: "translate(-291.879 -95.785)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M303.969,107.875a1.507,1.507,0,1,1,0,2.131A1.508,1.508,0,0,1,303.969,107.875Z",
    transform: "translate(-286.833 -90.739)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M282.228,86.134a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,282.228,86.134Z",
    transform: "translate(-281.787 -85.692)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12412",
    "data-name": "Group 12412",
    transform: "translate(44.756 29.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M388.619,153.669a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,388.619,153.669Z",
    transform: "translate(-321.4 -86.45)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M366.878,131.928a1.507,1.507,0,1,1,0,2.131A1.506,1.506,0,0,1,366.878,131.928Z",
    transform: "translate(-316.354 -81.403)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M345.138,110.188a1.507,1.507,0,1,1,0,2.131A1.508,1.508,0,0,1,345.138,110.188Z",
    transform: "translate(-311.307 -76.357)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M301.656,66.706a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,301.656,66.706Z",
    transform: "translate(-301.215 -66.264)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12413",
    "data-name": "Group 12413",
    transform: "translate(59.674 14.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M408.047,134.241a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,408.047,134.241Z",
    transform: "translate(-340.828 -67.022)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M386.306,112.5a1.507,1.507,0,1,1,0,2.131A1.506,1.506,0,0,1,386.306,112.5Z",
    transform: "translate(-335.781 -61.975)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M364.566,90.76a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,364.566,90.76Z",
    transform: "translate(-330.735 -56.929)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.694 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12414",
    "data-name": "Group 12414",
    transform: "translate(74.592 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(66.778 66.778)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(50.084 50.083)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M383.994,71.332a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,383.994,71.332Z",
    transform: "translate(-350.163 -37.501)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M362.253,49.591a1.507,1.507,0,1,1,0,2.132A1.508,1.508,0,0,1,362.253,49.591Z",
    transform: "translate(-345.117 -32.455)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M340.512,27.85a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,340.512,27.85Z",
    transform: "translate(-340.07 -27.409)",
    fill: "#ff5e1e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12418",
    "data-name": "Group 12418",
    transform: "translate(1160.543 -40.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M466.468,271.84a8.847,8.847,0,1,1,8.847-8.847A8.856,8.856,0,0,1,466.468,271.84Zm0-12.007a3.16,3.16,0,1,0,3.16,3.16A3.164,3.164,0,0,0,466.468,259.833Z",
    fill: "#7c0e6f"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Notifications",
    transform: "translate(951 173.566)",
    fill: "#7c0e6f",
    fontSize: 24,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Notifications"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBanner);
export default __webpack_public_path__ + "static/media/notifBanner.2114e8644ee53fc32adf403449ec0b8a.svg";
export { ForwardRef as ReactComponent };